require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-gwen-moore-raises-concerns-about-u-s-leadership.json") })
        }
      }, "path---en-us-update-gwen-moore-raises-concerns-about-u-s-leadership");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-gwen-moore-raises-concerns-about-u-s-leadership!./.cache/json/en-us-update-gwen-moore-raises-concerns-about-u-s-leadership.json
// module id = 673
// module chunks = 231608221292675